import { Injectable } from '@angular/core';

import { PartnerInscriptionData } from '../models/partner.model';

import { CnpjOfficeData } from './cnpj-lookup.service';

@Injectable({ providedIn: 'root' })
export class PartnerInscriptionDraftService {
  private readonly drafts = new Map<string, PartnerInscriptionData>();
  private latest: PartnerInscriptionData | undefined;

  private activeToken: string | undefined;

  /**
   * Troca de rota (comece-aqui → step-1) recria o formulário; os dados da consulta CNPJ
   * ficam aqui até a nova instância aplicar em tela.
   */
  private pendingCnpjOfficePrefill: CnpjOfficeData | undefined;
  private currentWizardStepRoute: 'step-1' | 'step-2' | 'step-3' | null = null;
  private allowedNextWizardStepRoute: 'step-1' | 'step-2' | 'step-3' | null = null;
  private allowWizardRouteChangeOnce = false;

  get(token: string): PartnerInscriptionData | undefined {
    return this.drafts.get(token.trim());
  }

  set(token: string, data: PartnerInscriptionData): void {
    this.drafts.set(token.trim(), data);
    this.latest = data;
  }

  /**
   * Guarda o último draft manipulado na sessão atual, mesmo sem token.
   * Garante hidratação entre steps quando ainda não há token emitido pelo back-end.
   */
  setLatest(data: PartnerInscriptionData): void {
    this.latest = data;
  }

  getLatest(): PartnerInscriptionData | undefined {
    return this.latest;
  }

  clearToken(token: string): void {
    this.drafts.delete(token.trim());
  }

  clearAll(): void {
    this.drafts.clear();
    this.latest = undefined;
    this.pendingCnpjOfficePrefill = undefined;
    this.activeToken = undefined;
    this.currentWizardStepRoute = null;
    this.allowedNextWizardStepRoute = null;
    this.allowWizardRouteChangeOnce = false;
  }

  setActiveToken(token: string): void {
    this.activeToken = token.trim();
  }

  getActiveToken(): string | undefined {
    return this.activeToken;
  }

  clearActiveToken(): void {
    this.activeToken = undefined;
  }

  setPendingCnpjOfficePrefill(data: CnpjOfficeData): void {
    this.pendingCnpjOfficePrefill = data;
  }

  consumePendingCnpjOfficePrefill(): CnpjOfficeData | undefined {
    const v = this.pendingCnpjOfficePrefill;
    this.pendingCnpjOfficePrefill = undefined;
    return v;
  }

  setCurrentWizardStepRoute(route: 'step-1' | 'step-2' | 'step-3' | null): void {
    this.currentWizardStepRoute = route;
  }

  getCurrentWizardStepRoute(): 'step-1' | 'step-2' | 'step-3' | null {
    return this.currentWizardStepRoute;
  }

  authorizeNextWizardStepRoute(route: 'step-1' | 'step-2' | 'step-3'): void {
    this.allowedNextWizardStepRoute = route;
  }

  consumeAuthorizedNextWizardStepRoute(): 'step-1' | 'step-2' | 'step-3' | null {
    const route = this.allowedNextWizardStepRoute;
    this.allowedNextWizardStepRoute = null;
    return route;
  }

  allowWizardRouteChange(): void {
    this.allowWizardRouteChangeOnce = true;
  }

  consumeWizardRouteChangePermission(): boolean {
    const allowed = this.allowWizardRouteChangeOnce;
    this.allowWizardRouteChangeOnce = false;
    return allowed;
  }
}
